export const UPDATE_VENUE_DELIVERYAREAS= 'UPDATE_VENUE_DELIVERYAREAS'
export const UPDATE_VENUE_DELIVERYAREAS_SUCCESS= 'UPDATE_VENUE_DELIVERYAREAS_SUCCESS'
export const UPDATE_VENUE_DELIVERYAREAS_ERROR='UPDATE_VENUE_DELIVERYAREAS_ERROR'

export const UpdateVenueDeliveryAreas= (data) => ({
    type: UPDATE_VENUE_DELIVERYAREAS,
    payload: data
})